import backend, {CAREGIVER_API} from 'utils/backend/server/api_library';

const getCaregiver = (caregiverRn, recommendationId) => {
  let url = `${CAREGIVER_API}/public/caregiver/${caregiverRn}`;
  if (recommendationId) {
    url = url + `?recommendation=${recommendationId}`;
  }
  return backend.get(url);
};

export default {
  getCaregiver,
};
